<template>
  <n-page-header class="subheader">
    <template #title>
      <n-space
        style="
          display: flex;
          flex-flow: row wrap;
          justify-content: flex-start;
          margin-top: 0px;
          margin-bottom: 0px;
          vertical-align: top;
        "
      >
        <iframe
          src="https://giphy.com/embed/gy4nYqDpBTXP9SYnRm"
          width="140"
          height="50"
          frameBorder="0"
          class="giphy-embed"
        ></iframe>
        <n-h1 style="margin-top: 2px">วันที่ {{ DateText }}</n-h1>
        <router-link :to="{ name: 'Home' }">
          <n-button quaternary circle type="primary">
            <template #icon>
              <n-icon :size="18">
                <InformationCircleOutline />
              </n-icon>
            </template>
          </n-button>
        </router-link>
      </n-space>
    </template>
    <template #extra>
      <n-space vertical style="margin-top: 2px">
        <ClockVueSlide></ClockVueSlide>
      </n-space>
    </template>
  </n-page-header>
  <n-carousel autoplay :interval="7000">
    <n-layout
      embedded
      content-style="padding: 24px; "
      v-for="item in dayScheduleSlide"
      :key="item.board"
    >
      <n-card v-if="item.blank" class="mainCard">
        <n-text class="headerBoard">
          {{ item.board }}
        </n-text>

        <n-h2 v-for="sitem in item.data" :key="sitem.no"> </n-h2>
      </n-card>
      <n-card v-else class="mainCard">
        <n-space justify="center">
          <n-text class="headerBoard">
            {{ item.board }}
          </n-text>
        </n-space>
        <n-h2>
          <n-divider title-placement="left" v-if="item.time">
            <n-text class="timeText">
              {{ item.time }}
            </n-text>
          </n-divider>
          <n-divider title-placement="left" v-else> </n-divider>
          <n-text
            type="primary"
            class="mainDes"
            v-if="item.description.length < 250"
          >
            {{ item.description }}
          </n-text>
          <n-text type="primary" class="mainMiniDes" v-else>
            {{ item.description }}
          </n-text>
          <n-divider title-placement="right">
            <n-text class="timeText">
              {{ item.no }} / {{ item.desLength }}
            </n-text>
          </n-divider>
        </n-h2>
      </n-card>
    </n-layout>
  </n-carousel>
</template>
<script>
import { defineComponent } from 'vue';
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { FirebaseDataService } from '../services/FirebaseDataServices';
import { DataServices } from '../services/DataServices';
import ClockVueSlide from '../components/ClockVueSlide.vue';
import { InformationCircleOutline } from '@vicons/ionicons5';
export default defineComponent({
  name: 'SlideSchedule',
  components: {
    ClockVueSlide,
    InformationCircleOutline,
  },
  setup() {
    const store = useStore();
    const DateText = ref(DataServices.ConvertDateToThai('now'));
    const daySchedule = ref(
      computed(() =>
        JSON.parse(JSON.stringify(store.state.daySchedule)),
      ),
    );
    const dayScheduleSlide = ref(
      computed(() =>
        JSON.parse(JSON.stringify(store.state.dayScheduleSlide)),
      ),
    );
    const columns = createColumns();
    onMounted(async () => {
      await store.dispatch('dayScheduleLoad').then(() => {});
      await store.dispatch('dayScheduleSlideLoad').then(() => {});
      FirebaseDataService.realtimeAwait();
    });
    function createColumns() {
      return [
        {
          title: 'เวลา',
          key: 'time',
          width: 70,
        },
        {
          title: 'วาระงาน',
          key: 'description',
          render(row) {
            return row.description;
          },
        },
      ];
    }
    return {
      DateText,
      daySchedule,
      dayScheduleSlide,
      columns,
    };
  },
});
</script>
<style scoped>
.n-gradient-text {
  font-size: 40px;
}
.mainDes {
  font-size: 75px;
  color: crimson;
}
.mainMiniDes {
  font-size: 60px;
  color: crimson;
}
.headerBoard {
  font-size: 80px;
  color: rgb(44, 0, 240);
}
.timeText {
  font-size: 60px;
  color: crimson;
}
.topdiviColor {
  border-top: 3px solid #bbb;
}
.botdiviColor {
  border-bottom: 3px solid #bbb;
}
.mainCard {
  background-color: yellow;
}
</style>
